import { createAction, props } from '@ngrx/store';
import { SoffQueryDto } from 'src/app/shared/models/query.model.dto';
import { IncomingTopicsSto, IncomingTopicTileDto, RelatedIncomingTopicTypeSto, RelatedObjectSto } from '../models/incoming-topic.model';

export const loadIncomingTopicsPage = createAction(
  '[Incoming Topics V2] Load incoming topics page',
  props<{ viewId: string; query: SoffQueryDto }>()
);

export const loadIncomingTopicsPageSuccessful = createAction(
  '[Incoming Topics V2] Load incoming topics page successful',
  props<{
    viewId: string;
    topics: IncomingTopicsSto[];
    topicsTotalCount: number;
    related: RelatedObjectSto[];
    query: SoffQueryDto;
  }>()
);

export const loadIncomingTopicsPageFailed = createAction('[Incoming Topics V2] Load incoming topics page failed', props<{ viewId: string }>());

export const changeIncomingTopicStatus = createAction(
  '[Incoming Topics V2] Change status',
  props<{ aggregateId: string; status: string; comment?: string }>()
);

export const changeIncomingTopicStatusSuccessful = createAction(
  '[Incoming Topics V2] Change status successful',
  props<{ aggregateId: string; status: string; comment?: string }>()
);

export const changeIncomingTopicStatusFailed = createAction('[Incoming Topics V2] Change status failed');

export const loadIncomingTopicDetails = createAction('[Incoming Topics V2] Load incoming topic details', props<{ aggregateId: string }>());

export const loadIncomingTopicDetailsSuccessful = createAction(
  '[Incoming Topics V2] Load incoming topic details successful',
  props<{ topic: IncomingTopicsSto; related: RelatedObjectSto[] }>()
);

export const loadIncomingTopicDetailsFailed = createAction('[Incoming Topics V2] Load incoming topic details failed');

export const assignResource = createAction(
  '[Incoming Topics V2] Assign resource',
  props<{ aggregateId: string; assignedResourceId: string | null }>()
);

export const assignResourceSuccessful = createAction(
  '[Incoming Topics V2] Assign resource successful',
  props<{ aggregateId: string; assignedResourceId: string | null }>()
);

export const assignResourceFailed = createAction('[Incoming Topics V2] Assign resource failed');

export const patchDueAt = createAction('[Incoming Topics V2] Patch due date', props<{ aggregateId: string; dueAt: string | null }>());

export const patchDueAtSuccessful = createAction(
  '[Incoming Topics V2] Patch due date successful',
  props<{ aggregateId: string; dueAt: string | null }>()
);

export const patchDueAtFailed = createAction('[Incoming Topics V2] Patch due date failed');

export const loadTiles = createAction('[Incoming Topics V2] Load tiles');

export const loadTilesSuccessful = createAction(
  '[Incoming Topics V2] Load tiles successful',
  props<{ tiles: IncomingTopicTileDto[]; types: RelatedIncomingTopicTypeSto[] }>()
);

export const loadTilesFailed = createAction('[Incoming Topics V2] Load tiles failed');
